import React from "react";
import { Spinner } from "reactstrap";

export const Loading1 = ({ height }) => {
    return (
      <div
        className="d-flex justify-content-center  align-items-center"
        style={{ height: height !== undefined ? height : "100vh" }}
      >
        <Spinner
          style={{ color: "rgba(128, 118, 103, 0.7)" }}
          type="grow"
        ></Spinner>
      </div>
    );
  };